const AvatarWithSource = () => <div className='user-avatar avatar-photo' />;
export default AvatarWithSource;
